<label for="selectFile">{{'fileUpload.browse' | translate}}</label>
<input
  pcsFileSelect
  id="selectFile"
  type="file"
  class="files-input"
  tabindex="-1"
  hidden
  [disabled]="disabled"
  [accepts]="accepts"
  [fileSize]="fileSize"
  (fileSelected)="fileSelected.emit($event)"
/>
